import { render, staticRenderFns } from "./IsFirstOccupation.vue?vue&type=template&id=864d00ec&"
import script from "./IsFirstOccupation.vue?vue&type=script&lang=ts&"
export * from "./IsFirstOccupation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports